import type { Kernel } from "@crialume/core";
import { QueryClient } from "@tanstack/react-query";

/**
 * Um único QueryClient para todos os módulos — cada módulo isola suas chaves
 * com `createQueryKeys(<id>)`. Substitui o InMemoryCacheManager do CadFrn,
 * que duplicava o papel do React Query.
 */
export function createQueryClient(kernel: Kernel): QueryClient {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
    },
  });

  // Logout/expiração: nenhum dado de um usuário sobrevive para o próximo.
  kernel.bus.on("auth:logout", () => queryClient.clear());
  kernel.bus.on("auth:session-expired", () => queryClient.clear());

  return queryClient;
}
